interface LogoProps {
  size?: number;
  withWordmark?: boolean;
}

export function Logo({ size = 32, withWordmark = true }: LogoProps) {
  return (
    <span data-bible-logo role="img" aria-label="Vammo Bible" className="inline-flex items-center gap-2">
      <svg aria-hidden="true" focusable="false" width={size} height={(size * 3) / 4} viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="bible-logo-page-edge" d="M18 5.5h13.5c1.8 0 3 1.3 3 3v22H18c-1.6 0-2.8-1.3-2.8-2.9V8.5c0-1.7 1.1-3 2.8-3Z" fill="#fff" stroke="#0BA4F9" strokeWidth="1.6" strokeLinejoin="round" />
        <path data-book-cover className="bible-logo-book" d="M16 3.5h14.5c1.9 0 3.2 1.3 3.2 3v22.2H15c-1.8 0-3-1.3-3-3.1V7.2c0-2.2 1.6-3.7 4-3.7Z" fill="#e8f5e4" stroke="#66BA50" strokeWidth="2.1" strokeLinejoin="round" />
        <path data-book-spine className="bible-logo-page" d="M17 4v24.5M21 10h8M21 14h8" stroke="#66BA50" strokeWidth="1.6" strokeLinecap="round" />
        <path className="bible-logo-clasp" d="M30 25v3.5" stroke="#0BA4F9" strokeWidth="2.2" strokeLinecap="round" />
        <circle className="bible-logo-clasp-dot" cx="30" cy="23.5" r="1.5" fill="#0BA4F9" />
        <path className="bible-logo-cross" d="M26 16v7m-3.5-3.5h7" stroke="#0BA4F9" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      {withWordmark ? (
        <span aria-hidden="true" className="bible-logo-wordmark text-foreground text-sm font-semibold tracking-tight">Vammo Bible</span>
      ) : null}
    </span>
  );
}
